import React from "react";
import services from "../../services";
import CountUp from "react-countup";
import { withRouter } from "react-router-dom";
import TableHeader from "./../common/table_header";
import TablePagination from "./../common/TablePagination.js";
import Lang from "../../lang";
import Main from "../../Pages/Demo/main";
import SearchFilter from "../filters/SearchFilter";
import TitleBar from "../common/title_bar";
import FilterInputs from "../filters/FilterInputs";
import TkTablewithAction from "../tlelrik/TkTablewithAction";
import $ from "jquery";
// import TlkTable from '../tlelrik/table/tlkTable';
import TlkTableparcel from "../tlelrik/table/TlkTableparcel";
import WizardDetailModalForm from "../common/wizard_detail_popup";
import EntityDetails from "../common/EntityDetails";
import ParcelVirsion from "../Parcel-Right-panel/ParcelVirsion";
import GoogleMapPopUp from "../common/GoogleMapPopUp";
import { toast } from "react-toastify";

const columnkeyMap = {
    numparc: "Nº Parcela IVDP",
    geocod: "GeoCódigo",
    numparant: "Nº Parcela CD",
    sitedeclar: "Declaração",
    legalizavel: "Legislável",
    districtName: "Distrito",
    countryName: "Concelho",
    parishName: "Freguesia",
    classe: "Classe",
    // mcp: "Número",
    areaapta: "Área Apta",
    areailegal: "Área s/ enq legal",
    areanapta: "Área não Apta",
    areaaf: "A a F com MG",
    anoplantacao: "Ano de Plantação",
    // "designment":"designacao",
    // "punctuation":"pontuacao",
    // "lastSurveyDate":"dataultimavistoria",
    // "plotSituation":"situacaodaparcela",
    // "vineyardStatus":"estadodavinha",
    // "groudFrame":"armacaotereno",
    // "estimatedProduction":"producaoestimada",
    // "litigationSituation":"situacaodedelitigio",
    // "classPlantation":"classePlantacao",
    // "potentialarea":"AreaPotential",
    // "affectiveArea":"AreaAfetiva",
    // "areaWithoutEnqNice":"AreasEnqLegal",
    // "doPort":"FactorDOPorto",
    // "fitnessFactor":"FactorAptidao",
    // "factorPortGrapeVarieties":"factorpartocastas",
};
const TabName = [
    {
        name: "Total de área apta",
        key: "areaapta",
    },
    {
        name: "Total de área não apta",
        key: "areanapta",
    },
    {
        name: "Total A a F com MG",
        key: "areaaf",
    },
    {
        name: "Total área s/ enquadramento legal",
        key: "areailegal",
    },
];

const filters = {
    Tabs: {
        Entidade: [
            // {
            //     key: 'numparc',
            //     displayKey: "Nº Parcela IVDP",
            //     inputType: "text"
            // },
            // {
            //     key: 'numparant',
            //     displayKey: " Nº Parcela CD",
            //     inputType: "text"
            // },
            //   {
            //       key : 'declaration',
            //       displayKey : "Declaracao",
            //       inputType : "text"
            //   }
        ],
        Parcela: [
            {
                key: "pontuacao",
                displayKey: "pontuação",
                inputType: "text",
            },
            {
                key: "numparc",
                displayKey: "Nº Parcela IVDP",
                inputType: "text",
            },
            {
                key: "numparant",
                displayKey: " Nº Parcela CD",
                inputType: "text",
            },
        ],
        Geocódigo: [
            {
                key: "countryName",
                displayKey: "Concelho",
                inputType: "text",
            },
            {
                key: "parishName",
                displayKey: "Freguesia",
                inputType: "text",
            },
            {
                key: "geocod",
                displayKey: "Geocódigo",
                inputType: "text",
            },
        ],
        // Freguesia:[
        //     {
        //         key : 'lastSurveyDate',
        //         displayKey : "Dataultimavistoria",
        //         inputType : "text"
        //     }
        // ],
        "Ficha de exploração": [
            {
                key: "anoplantacao",
                displayKey: "Ano de plantação",
                inputType: "text",
            },
            // ,
            // {
            //     key: 'mcp',
            //     displayKey: "Número",
            //     inputType: "text"
            // }
            // {
            //     key : 'plotSituation',
            //     displayKey : "Situacaodaparcela",
            //     inputType : "text"
            // },
            // {
            //     key : 'affectiveArea',
            //     displayKey : "AreaAfetiva",
            //     inputType : "text"
            // }
        ],
        //     AP:[
        //         {
        //             key : 'doPort',
        //             displayKey : "FactorDOPorto",
        //             inputType : "text"
        //         },
        //         {
        //             key : 'fitnessFactor',
        //             displayKey : "FactorAptidao",
        //             inputType : "text"
        //         }
        //     ]
    },
    checkbox: [
        {
            key: "Explorer",
            displayKey: "Exploradora",
            inputType: "radio",
        },
        {
            key: "Owner",
            displayKey: "Proprietária",
            inputType: "radio",
        },
        {
            key: "Explorer/Owner",
            displayKey: "Ambos",
            inputType: "radio",
        },
    ],
};

const groupfield = [
    //{ field: "Nº Parcela IVDP" },
    { field: "Distrito" },
    { field: "Concelho" },
    { field: "Freguesia" },
];

const aggregates = [
    { field: "Área Apta", aggregate: "sum" },
    { field: "Área s/ enq legal", aggregate: "sum" },
    { field: "Área não Apta", aggregate: "sum" },
    { field: "A a F com MG", aggregate: "sum" },
];

/* Array de configurações estáticas da página*/
const optionMenuArray = [
    { main: "Tabelas de Gestão" },
    { main: "Enquadramento Legal" },
];
// const getkeyTableName = (res, key, customkey) => {

//     if (customkey !=="") {
//         if (customkey === "Explorer") {
//             return "explorer";
//         } else if (customkey === "Owner") {
//             return "property";
//         } else if (customkey === "Explorer/Owner") {
//             return "explorer_property";
//         }
//     }
//     else {
//         if (key in res.parcel) {
//             return "parcelfilter";
//         } else if (key in res.parcelProperty && key in res.parcelExplorer) {
//             return "explorer_property";
//         } else if (key in res.parcelProperty) {
//             return "property";
//         } else if (key in res.parcelExplorer) {
//             return "explorer";
//         }
//     }
//     return false;
// }

let cond = 0;
class DashBoardFilter extends React.Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            telkikTable: "",
            showSearchMsg: false,
            totalcount: 0,
            entity_list_object: {},
            customfilters: {},
            tlkfilter: {},
            clickLimparFilter: false,
            date: new Date(),
            tabsComponentsView: null,
            popUpForm: "",
            popUpForm2: "",
        };
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        $(window).scrollTop(0);
        // this.createTabel();
    }

    componentDidUpdate(proProp) {
        if (proProp.date !== this.props.date) {
            this.setState({
                date: new Date(),
                clickLimparFilter: this.props.clickLimparFilter,
            });
        }
    }

    /* Para baixar o arquivo lang json */
    getLangFile = () => {
        Lang.getJSON.getJSONFile();
    };

    /* Para obter dados filtrados do componente de filtro personalizado  */

    handleFilter = (data) => {};

    /* Para carregar o componente da tabela e definir todas as colunas  */

    createTabel = () => {
        let columnlist = Object.keys(columnkeyMap).map(function (key) {
            return { field: columnkeyMap[key], columnMenuType: "checkbox" };
        });
        let notFilterColumn = {
            "Área Apta": true,
            "Área s/ enq legal": true,
            "Área não Apta": true,
            "A a F com MG": true,
        };
        let actionbuttons = {
            Edit: true,
            Redirect: false,
            Delete: false,
            Dropdown: true,
        };
        let telkikTable = (
            <TlkTableparcel
                date={new Date()}
                sendDatatoTlkTable={(filter) => this.sendDatatoTlkTable(filter)}
                aggregates={aggregates}
                notFilterColumn={notFilterColumn}
                list={this.state.data}
                modulename={"dashboard"}
                tlkState={this.state.tlkfilter}
                groupfield={groupfield}
                deleteFunc={(id) => this.handleDelete(id)}
                actionbuttons={actionbuttons}
                columnlist={columnlist}
                ActionPerform={(action, id) => this.ActionPerform(action, id)}
                columnwidth={60}
                actionColWidth={70}
            />
        );
        this.setState({
            telkikTable,
        });
    };

    /*  Para obter a chave de filtros dos filtros personalizados para recuperar a API com base nisso */

    /* Obter a chave do filtro do filtro personalizado */

    getFilters(filters) {
        // console.log("filters",filters);
        this.setState(
            {
                customfilters: filters,
                totalcount: 0,
                showSearchMsg: true,
                telkikTable: null,
                clickLimparFilter: false,
                tabsComponentsView: null,
            },
            () => {
                if (
                    filters &&
                    Object.keys(filters.filters).length === 0 &&
                    Object.keys(filters.filterCheckbox).length === 0
                ) {
                    this.setState({ showSearchMsg: false });
                    return;
                } else if (
                    filters &&
                    (Object.keys(filters.filters).length > 0 ||
                        Object.keys(filters.filterCheckbox).length > 0)
                ) {
                    this.sendDatatoTlkTable({});
                    // this.createTabel()
                }
            }
        );
    }

    /* Tornar todos os tipos de filtros personalizados e tabelas em formatos de API */

    makeAllfilters = (tlfilter) => {
        let customfilters = { ...this.state.customfilters };
        let tlkfilter = tlfilter;
        if (Object.keys(tlkfilter).length === 0) {
            tlkfilter = { ...this.state.tlkfilter };
        }
        //console.log("customfilters", customfilters);
        //console.log("tlkfilter", tlkfilter);
        let booleankeys = {
            sitedeclar: true,
            legalizavel: true,
        };

        let filters = {
            explorerentnum: null,
            ownerentnum: null,
            entnum: null,
        };

        let entityFilter = {
            Explorer: "explorerentnum",
            Owner: "ownerentnum",
            "Explorer/Owner": "entnum",
        };
        let data = {
            Filters: {},
            SortBy: "numparc",
            IsSortTypeDESC: false,
            IsPagination: true,
            Page: Math.ceil(tlkfilter.skip / tlkfilter.take) + 1 || 1,
            PageSize: tlkfilter.take || 100,
        };
        data = services.getAllFilters.addBoth(
            customfilters,
            tlkfilter,
            columnkeyMap,
            data,
            booleankeys,
            filters,
            entityFilter
        );
        delete data.Filters.explorerlike;
        delete data.Filters.ownerlike;
        delete data.Filters["explorer/ownerlike"];
        // data.Filters.numparc = 1;
        return data;
    };

    /*  Atualizar os dados da tabela em chamadas de API dinâmicas */

    sendDatatoTlkTable = async (tlkfilter) => {
        // debugger
        this.setState({
            tlkfilter: tlkfilter,
            tabsComponentsView: null,
        });
        let data = this.makeAllfilters(tlkfilter);
        let portugasdata = [];
        let url = "/Parcel/GetAll";
        let _Parcel = await services.apiCall.requestApi(url, data, "post");

        if (+window.localStorage.getItem("table_total") > 100) {
            cond++;
        }

        if (cond % 2 == 1) {
            toast.success(
                "A pesquisa efetuada retornou mais de 100 resultados. Por favor, redefina os seus critérios de pesquisa."
            );
        }

        if (_Parcel && _Parcel.length > 0) {
            _Parcel.map(
                (_row, index) => (
                    (portugasdata[index] = _row.parcel),
                    (portugasdata[index]["parcelProperty"] =
                        _row.parcelProperty),
                    (portugasdata[index]["parcelExplorer"] =
                        _row.parcelExplorer),
                    (portugasdata[index]["areaapta"] = 0),
                    (portugasdata[index]["areailegal"] = 0),
                    (portugasdata[index]["areanapta"] = 0),
                    // portugasdata[index]['anoplantacao'] = 0,
                    (portugasdata[index]["areaaf"] = 0),
                    _row.parcelExplorer.map(
                        (row) => (
                            (portugasdata[index]["areaapta"] += row.areaapta
                                ? eval(row.areaapta)
                                : 0),
                            (portugasdata[index]["areailegal"] +=
                                row.areailegal || 0),
                            (portugasdata[index]["areanapta"] +=
                                row.areanapta || 0),
                            // portugasdata[index]['anoplantacao'] += row.anoplantacao || 0
                            (portugasdata[index]["areaaf"] += row.areaaf || 0)
                        )
                    ),
                    Object.keys(columnkeyMap).map(function (key) {
                        portugasdata[index][columnkeyMap[key]] =
                            portugasdata[index][key];
                    })
                )
            );

            this.setState(
                {
                    data: portugasdata,
                    showSearchMsg: false,
                    totalcount: window.localStorage.getItem("table_total"),
                },
                () => {
                    if (data.Filters.explorerentnum > 0)
                        this.getEntityDetails(data.Filters.explorerentnum);
                    else if (data.Filters.ownerentnum > 0)
                        this.getEntityDetails(data.Filters.ownerentnum);
                    else if (data.Filters.entnum > 0)
                        this.getEntityDetails(data.Filters.entnum);

                    this.createTabel();
                }
            );
            // return portugasdata;
        } else {
            this.setState({
                showSearchMsg: true,
                data: [],
                telkikTable: null,
                totalcount: 0,
            });
        }
    };

    /* Deletar linha da tabela de dados */

    handleDelete = (id) => {};

    /*  Para realizar a ação com base na seleção da tabela  */

    ActionPerform = async (action, row) => {
        let popUpForm = "";
        let popUpForm2 = "";
        if (action === "Edit") {
            // window.location = "/wizard_form?id=" + row.numparc + "&versao=" + row.versao + "&geocode=" + row.geocod + "&status=" + row.status
            this.props.history.push({
                pathname: "/wizard_form",
                search: "?id=" + row.numparc + "&versao=" + row.versao,
            });
        } else if (action === "Map") {
            popUpForm = <GoogleMapPopUp />;
            this.setState({ popUpForm });
        } else if (action === "History") {
            popUpForm2 = (
                <WizardDetailModalForm
                    tab="versions"
                    id={row.numparc}
                    listData={row}
                />
            );
            this.setState({ popUpForm2 });
        } else if (action === "Print") {
            let data = {
                id: +row.numparc,
                versao: +row.versao,
            };
            let res = await services.apiCall.requestApi(
                "/Parcel/GetPDFById",
                data,
                "post"
            );
            if (res) {
                services.goto.newTab("api/" + res.url);
            }
        }
    };

    /*Para obter detalhes de uma única entidade usando api */

    getEntityDetails = async (entity_id) => {
        let Request = {};
        this.setState({
            entity_details: null,
        });
        Request.entityId = parseInt(entity_id);
        let link = "/Revenue/getEntityDetail";
        let res = await services.apiCall.requestApi(link, Request);
        if (res) {
            this.setState(
                {
                    entity_details: res,
                },
                () => this.tabSectionView(this.state.data)
            );
        }
    };

    tabSectionView = (data) => {
        let tabsComponentsView = "";
        if (data === "") {
            tabsComponentsView = "";
        } else {
            let tabSectionView = {
                areaapta: 0,
                areanapta: 0,
                areailegal: 0,
                areaaf: 0,
            };
            data.map((_r) => {
                tabSectionView["areaapta"] += _r.areaapta;
                tabSectionView["areanapta"] += _r.areanapta;
                tabSectionView["areailegal"] += _r.areailegal;
                tabSectionView["areaaf"] += _r.areaaf;
            });
            //console.log("tabSection", tabSectionView)
            tabsComponentsView = (
                <div className="tab-section">
                    <div className="d-md-flex justify-content-between">
                        {TabName.map((_n, i) => (
                            <div key={i} className="innerBox">
                                <p>{_n.name}</p>
                                <h1>{tabSectionView[_n.key]}</h1>
                            </div>
                        ))}
                        <EntityDetails
                            className="innerBox active d-flex align-items-center cursor-pointer"
                            entity={this.state.entity_details.busEntidade}
                            onlyDetails={true}
                            entityContact={
                                this.state.entity_details.v_CC_Entidade_Contact
                            }
                            billobj={this.state.entity_details.billing_address}
                        />
                    </div>
                </div>
            );
        }
        this.setState({
            tabsComponentsView,
        });
    };

    refreshComponent = () => {
        this.setState({ clickLimparFilter: true });
    };

    // showEntityDetailPopUp = () => {
    //     let row = this.state.entity_list_object[this.state.popUpEntity]
    //     let detailPopUp = (
    //         <WizardDetailModalForm listData={row} tab={'detail'} />
    //     )
    //     this.setState({
    //         detailPopUp
    //     })
    // }

    /*  Para renderizar o conteúdo html da página   */

    render() {
        // const rend = Math.random();
        // rend=879;
        return (
            <div className="inner-container">
                <div className="outer-space">
                    <TitleBar
                        refreshComponent={() => this.refreshComponent()}
                        path={"/wizard_form"}
                        onlyInicioLink={"/dashboard"}
                        title="Parcela"
                        logo="parcelas"
                        optionMenuArray={optionMenuArray}
                    />
                </div>
                <div className="container-fluid">
                    <SearchFilter
                        showEntity={true}
                        date={this.state.date}
                        filters={filters}
                        clickLimparFilter={this.state.clickLimparFilter}
                        handleFilter={(data) => this.handleFilter(data)}
                        data={this.state.data}
                        getFilter={(data) => this.getFilters(data)}
                    />

                    {this.state.tabsComponentsView}

                    <div className="table-section">
                        {
                            <>
                                {
                                    <div
                                        className={
                                            this.state.data &&
                                            this.state.data.length
                                                ? ""
                                                : "tlkwodata"
                                        }
                                    >
                                        {this.state.totalcount > 0 && (
                                            <h3>
                                                {" "}
                                                A pesquisa retornou{" "}
                                                {this.state.totalcount}{" "}
                                                resultados{" "}
                                            </h3>
                                        )}
                                        <div className="table-responsive">
                                            {this.state.telkikTable}
                                        </div>
                                    </div>
                                }
                                {this.state.totalcount == 0 && (
                                    <div className="searct-found">
                                        <img
                                            className="img-fluid"
                                            src="imgs/search-large-icon.png"
                                        />
                                        {this.state.showSearchMsg ? (
                                            <p className="font-14">
                                                Sem resultados
                                            </p>
                                        ) : (
                                            <h3>
                                                Pesquise uma instalação ou
                                                entidade para apresentação de
                                                mais informações
                                            </h3>
                                        )}
                                    </div>
                                )}
                            </>
                        }
                    </div>
                    {
                        <div className="modal" id="google-map-popup">
                            <div className="modal-dialog modal-lg">
                                {this.state.popUpForm}
                            </div>
                        </div>
                    }
                    {
                        <div className="modal left-popup" id="parcelPopups">
                            <div className="modal-dialog modal-lg">
                                {this.state.popUpForm2}
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default withRouter(DashBoardFilter);
